import React from "react";
import {
  Paper,
  Typography,
  Divider,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { ReorderStatusChip } from "../tracker/ReorderReport";
import { formatDate } from "../tracker/StockActionDialog";

const ViewProduct = ({ product }) => {
  if (!product) {
    return null;
  }

  const formatCost = (value) =>
    value !== null && value !== undefined ? `$${Number(value).toFixed(2)}` : "";

  return (
    <Paper elevation={2} sx={{ p: 2, mt: 2 }}>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Product Overview
      </Typography>
      <Divider sx={{ mb: 1.5 }} />

      <Grid container spacing={1.5}>
        <Grid item xs={12} sm={4} md={2}>
          <Typography variant="body2">Product: {product.productName}</Typography>
        </Grid>
        <Grid item xs={12} sm={4} md={2}>
          <Typography variant="body2">Vendor: {product.vendorName}</Typography>
        </Grid>
        <Grid item xs={12} sm={4} md={2}>
          <Typography variant="body2">Item Number: {product.sku}</Typography>
        </Grid>
        <Grid item xs={12} sm={4} md={2}>
          <Typography variant="body2">UPC: {product.upc}</Typography>
        </Grid>
        <Grid item xs={12} sm={4} md={2}>
          <Typography variant="body2">Category: {product.category}</Typography>
        </Grid>
        <Grid item xs={12} sm={4} md={2}>
          <Typography variant="body2">
            Order Level: {product.orderLevel}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4} md={2}>
          <Typography variant="body2">
            Production / Shipping Leadtime: {product.leadTimeDays}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4} md={2}>
          <Typography variant="body2">
            Cost: {formatCost(product.cost)}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4} md={2}>
          <Typography variant="body2">
            Burn Rate / Week: {product.reorder?.burnRate ?? "-"}{" "}
            ({product.useCalculatedBurnRate ? "60 days" : "manual"})
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4} md={2}>
          <Typography variant="body2" component="div">
            Reorder Point: {product.reorder?.reorderPoint ?? "-"}{" "}
            <ReorderStatusChip status={product.reorder?.reorderStatus} />
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4} md={2}>
          <Typography variant="body2">
            Current Stock Level: {product.currentStockLevel}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4} md={2}>
          <Typography variant="body2">
            Active: {product.isActive ? "Yes" : "No"}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={8} md={4}>
          <Typography variant="body2">
            Description: {product.description}
          </Typography>
        </Grid>
      </Grid>

      <Divider sx={{ my: 1.5 }} />
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Variants
      </Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Variant</TableCell>
            <TableCell>Item Number</TableCell>
            <TableCell>UPC</TableCell>
            <TableCell>Cost</TableCell>
            <TableCell>Stock</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(product.variants || []).map((variant) => (
            <TableRow key={variant.id}>
              <TableCell>{variant.variantName}</TableCell>
              <TableCell>{variant.sku}</TableCell>
              <TableCell>{variant.upc}</TableCell>
              <TableCell>{formatCost(variant.cost)}</TableCell>
              <TableCell>{variant.currentStockLevel}</TableCell>
            </TableRow>
          ))}
          {(product.variants || []).length === 0 && (
            <TableRow>
              <TableCell colSpan={5}>
                <Typography variant="body2" color="textSecondary">
                  No variants
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>

      <Divider sx={{ my: 1.5 }} />
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Locations &amp; Stock
      </Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Location</TableCell>
            <TableCell>Variant</TableCell>
            <TableCell>Lot</TableCell>
            <TableCell>Expiration</TableCell>
            <TableCell>Stock Level</TableCell>
            <TableCell>Notes</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(product.locations || []).map((location) => (
            <TableRow key={location.id}>
              <TableCell>{location.locationName}</TableCell>
              <TableCell>{location.variantName || "(product)"}</TableCell>
              <TableCell>{location.lotNumber}</TableCell>
              <TableCell>{formatDate(location.expirationDate)}</TableCell>
              <TableCell>{location.stockLevel}</TableCell>
              <TableCell>{location.notes}</TableCell>
            </TableRow>
          ))}
          {(product.locations || []).length === 0 && (
            <TableRow>
              <TableCell colSpan={6}>
                <Typography variant="body2" color="textSecondary">
                  No locations recorded
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default ViewProduct;
